import { render, staticRenderFns } from "./startConversation.vue?vue&type=template&id=f0f0fcf2&"
import script from "./startConversation.vue?vue&type=script&lang=ts&"
export * from "./startConversation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports